import React from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import validateFullName from './validator';
import { FormGroup } from '../../../common-components';
import { clearRegistrationBackendError } from '../../data/actions';
import { useIntl } from '@edx/frontend-platform/i18n';

/**
 * Name field wrapper. It accepts following handlers
 * - handleChange for setting value change and
 * - handleErrorChange for setting error
 *
 * It is responsible for
 * - Making backend call for generating username suggestions
 * - Performing name field validations
 * - Clearing error on focus
 * - Setting value on change
 */
const NameField = (props) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const {
    handleErrorChange,
    fieldName,
  } = props;

  const handleOnBlur = (e) => {
    const { value } = e.target;
    const error = validateFullName(value, formatMessage);
    if (error) {
      handleErrorChange(fieldName, error);
    }
  };

  const handleOnFocus = () => {
    handleErrorChange(fieldName, '');
    dispatch(clearRegistrationBackendError(fieldName));
  };

  return (
    <FormGroup
      {...props}
      handleFocus={handleOnFocus}
      handleBlur={handleOnBlur}
    />
  );
};

NameField.defaultProps = {
  errorMessage: '',
  shouldFetchUsernameSuggestions: false,
  fieldName: '',
};

NameField.propTypes = {
  errorMessage: PropTypes.string,
  shouldFetchUsernameSuggestions: PropTypes.bool,
  value: PropTypes.string.isRequired,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default NameField;
